import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { ThemeProvider } from "@/hooks/use-theme";
import { DensityProvider } from "@/hooks/use-density";
import { AuthProvider } from "@/app/auth-context";
import { ConfirmProvider } from "@/components/confirm-dialog";
import { Toaster } from "@/components/ui/sonner";
import { AppErrorBoundary } from "@/app/error-boundary";

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );
  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <>
          <ThemeProvider>
            <DensityProvider>
              <AuthProvider>
                <ConfirmProvider>{children}</ConfirmProvider>
              </AuthProvider>
            </DensityProvider>
          </ThemeProvider>
          <Toaster richColors closeButton />
        </>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
}
